import { useEffect } from "react";

import { IPhoneFrame } from "@/components/onboarding/iphone-frame";
import { useServiceStore } from "@/stores/service-store";
import { useServiceQuery } from "@/hooks/use-services";

export function WidgetPreview() {
  const { selectedService, selectedServiceId, setSelectedService } = useServiceStore();

  // After a page refresh the store has only the ID, not the service object.
  const { data: fetchedService } = useServiceQuery(selectedServiceId ?? "");

  useEffect(() => {
    if (fetchedService && !selectedService) {
      setSelectedService(fetchedService);
    }
  }, [fetchedService, selectedService, setSelectedService]);

  const service = selectedService ?? fetchedService;

  return (
    <div className="flex justify-center">
      <div className="relative h-[220px] overflow-hidden [mask-image:linear-gradient(to_bottom,black_60%,transparent)]">
        <IPhoneFrame>
          <div className="px-4 pt-4">
            <div className="w-[120px] h-[120px] rounded-3xl bg-white p-3 shadow-sm flex flex-col items-center justify-center gap-2">
              {service?.logo_url ? (
                <img
                  src={service.logo_url}
                  alt="Service logo"
                  className="w-[60px] h-[60px] object-contain rounded-lg"
                />
              ) : (
                <div className="w-[60px] h-[60px] rounded-lg bg-blue-500 flex items-center justify-center">
                  <span className="text-white font-bold text-2xl">A</span>
                </div>
              )}
              <p className="text-[13px] font-medium text-gray-900 text-center truncate w-full px-1">
                {service?.title || "Your Service"}
              </p>
            </div>
          </div>
        </IPhoneFrame>
      </div>
    </div>
  );
}
